import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomCard from '../../../components/Antd/Card';
import CustomTable from '../../../v2-components/Antd/Table';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import { Service } from '../service';
import DeleteProductModal from './components/DeleteProductModal';
import DropdownTable from './components/DropdownTable';
import EditOfferModal from './components/EditOfferModal';
import EditPriceModal from './components/EditPrIceModal';
import EditQuantityModal from './components/EditQuantityModal';
import RecipeModal from './components/RecipeModal';
import ReserveProgress from './components/ReserveProgress';
import StatusCard from './components/StatusCard';
import { dictionaryInformation } from './constants/dictionary-information.constant';
import { notifications } from './constants/notifications.constant';
import { checkProducts } from './handle/check-products.handle';
import { checkRetirement } from './handle/check-retirement.handle';
import { checkRol } from './handle/check-rol.handle';
import { clientInfoAdapter } from './handle/client-info-adapter.handle';
import { coverageInfoAdapter } from './handle/coverage-info-adapter.handle';
import { generateCoverageColumns } from './handle/generate-coverage-columns.handle';
import { generateDeliveryColumns } from './handle/generate-delivery-columns.handle';
import { generateHomeDeliveryInfoColumns } from './handle/generate-home-delivery-columns.handle';
import { generateProductColumns } from './handle/generate-product-columns.handle';
import { generateClientColumns } from './handle/gererate-client-columns.handle';
import { homeDeliveryInfoAdapter } from './handle/home-delivery-info-adapter.handle';
import { orderInfoAdapter } from './handle/order-info-adapter.handle';
import { productInfoAdapter } from './handle/product-info-adapter.handle';
import Loading from '../../../v2-components/Loading';

export default function ReserveDetailPage() {
	const { trx_id } = useParams();
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [openDelete, setOpenDelete] = useState();
	const [openEditPrice, setOpenEditPrice] = useState(false);
	const [record, setRecord] = useState();
	const [openRecipe, setOpenRecipe] = useState(false);
	const [recipe, setRecipe] = useState();
	const [openEditOffer, setOpenEditOffer] = useState(false);
	const [openEditQuantity, setOpenEditQuantity] = useState(false);
	const [renderData, setRenderData] = useState(false);
	const [productToDelete, setProductToDelete] = useState();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const reserveNumber = data?.operation_id;
	const statusNumber = data?.status?.status;
	const status = data?.status;
	const id = data?._id;

	useEffect(() => {
		new Service().getReserveByTrxId(trx_id).then((response) => {
			setData(response);
			setIsLoading(false);
		});
	}, [trx_id, renderData]);

	const handleDeleteProduct = (items) => {
		setRenderData(false)
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service().editReserveProducts(id, items).then((response) => {
			setData(response);
			setIsLoadingModal(false);
			setOpenLoadingModal(false);
			setRenderData(true);
		});
	};

	const handleCancelReserve = (body) => {
		setRenderData(false)
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.postChangeStatus(id, 300, body)
			.then((response) => {
				setOpenLoadingModal(false);
				setIsLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Estado de la reserva', description: notifications[Enviroment.LANGUAGE].rejected });
				setRenderData(true);
			})
			.catch((error) => {
				CustomNotification({ type: 'error', message: null, description: notifications[Enviroment.LANGUAGE].error });
			});
	};

	const handleApproveReserve = (body) => {
		setRenderData(false)
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.postChangeStatus(id, 200, body)
			.then((response) => {
				if (response.statusCode === 400) {
					setIsLoadingModal(false);
					setOpenLoadingModal(false);
					CustomNotification({ type: 'error', message: null, description: notifications[Enviroment.LANGUAGE].link });
					return;
				}
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Estado de la reserva', description: notifications[Enviroment.LANGUAGE].approved });
				setRenderData(true);
			})
			.catch((error) => {
				CustomNotification({ type: 'error', message: null, description: notifications[Enviroment.LANGUAGE].error });
			});
	};

	const handleOpenDelete = (productInfo) => {
		setOpenDelete(true);
		setProductToDelete(productInfo);
	};

	const handleConfirmDelete = (items) => {
		setOpenDelete(false);
		handleDeleteProduct(items);
	};

	const handleConfirmEdit = (items) => {
		setOpenEditPrice(false);
		handleDeleteProduct(items);
	};
	const handleConfirmOffer = (items) => {
		setOpenEditOffer(false);
		handleDeleteProduct(items);
	};
	const handleOpenEditPrice = (data) => {
		setOpenEditPrice(true);
		setRecord(data);
	};

	const handleOpenEditOffer = (data) => {
		setOpenEditOffer(true);
		setRecord(data);
	};

	const handleOpenRecipe = (recipe) => {
		setRecipe(recipe);
		setOpenRecipe(true);
	};
	const handleOpenEditQuantity = (data) => {
		setOpenEditQuantity(true);
		setRecord(data);
	};
	const handleConfirmQuantity = (items) => {
		setOpenEditQuantity(false);
		handleDeleteProduct(items);
	};

	if (isLoading) {
		return <Loading /> ;
	}
	return (
		<>
			<Col span={8}>
				<h2> {`Solicitud N° ${reserveNumber}`} </h2>
				<Link to={checkRol(data?.pharmacy)}>Volver a solicitudes</Link>
			</Col>
			<Row gutter={[16, 16]}>
				<Col span={12}>
					<ReserveProgress data={data} />
				</Col>
				<Col span={12}>
					<CustomCard style={{ width: 400 }}>
						<StatusCard
							handleCancelReserve={handleCancelReserve}
							handleApproveReserve={handleApproveReserve}
							statusNumber={statusNumber}
							status={status}
							isLoading={isLoading}
							setIsLoading={setIsLoading}
						/>
					</CustomCard>
				</Col>
			</Row>
			<Col span={24} style={{ display: checkRetirement(data?.info?.type_retirement) }}>
				<h3>{dictionaryInformation[Enviroment.LANGUAGE].home_delivery}</h3>
				<CustomTable columns={generateHomeDeliveryInfoColumns()} pagination={false} dataSource={homeDeliveryInfoAdapter(data)} />
			</Col>
			<Row>
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].client}</h3>
					<CustomTable columns={generateClientColumns()} pagination={false} dataSource={clientInfoAdapter(data)} />
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].order}</h3>
					<CustomTable columns={generateDeliveryColumns()} pagination={false} dataSource={orderInfoAdapter(data)} />
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].coverage}</h3>
					<CustomTable columns={generateCoverageColumns()} pagination={false} dataSource={coverageInfoAdapter(data)} />
				</Col>
			</Row>
			<Row className={'own-product-container'}>
				<Col span={24}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].products}</h3>
					{checkProducts(status?.status, data?.products_details)}
					<CustomTable
						columns={generateProductColumns(
							status?.status,
							handleOpenEditOffer,
							handleOpenEditPrice,
							handleOpenRecipe,
							handleOpenEditQuantity,
							handleOpenDelete,
						)}
						dataSource={productInfoAdapter(data?.products_details)}
						expandable={{ expandedRowRender: (record) => <DropdownTable status={status?.status} record={record} /> }}
					/>
					<DeleteProductModal
						handleConfirmDelete={handleConfirmDelete}
						setOpenDelete={setOpenDelete}
						openDelete={openDelete}
						productInfo={productToDelete}
					/>
					<EditQuantityModal
						record={record}
						handleConfirmQuantity={handleConfirmQuantity}
						openEditQuantity={openEditQuantity}
						setOpenEditQuantity={setOpenEditQuantity}
					/>

					<EditPriceModal
						record={record}
						handleConfirmEdit={handleConfirmEdit}
						openEditPrice={openEditPrice}
						setOpenEditPrice={setOpenEditPrice}
					/>
					<RecipeModal openRecipe={openRecipe} setOpenRecipe={setOpenRecipe} recipe={recipe} />
					<EditOfferModal
						handleConfirmOffer={handleConfirmOffer}
						openEditOffer={openEditOffer}
						setOpenEditOffer={setOpenEditOffer}
						record={record}
					/>
					<LoadingModal loading={isLoadingModal} visible={openLoadingModal} />
				</Col>
			</Row>
		</>
	);
}
